<template>
  <section id="sw-mailing-list">
    <header>Получатели:</header>

    <ul>
      <li
        v-for="({name, id}, index) in receivers"
        :key="'addressee-' + id"
      >
        <span>{{ index + 1 }}) {{ name }}</span>

        <VButton
          material="delete"
          @click="removeEmployee(index)"
        />
      </li>
    </ul>

    <footer>
      <VSelect
        v-model="addressInput"
        placeholder="Введите ФИО сотрудника"
        layout="vertical"
        :search-function="SWPortalTasksService.getListEmployees"
      />

      <VButton
        theme="primary"
        :disabled="addressInput === null"
        @click="addEmployee"
      >
        <template #icon>
          <VIcon material="add" />
        </template>
      </VButton>
    </footer>
  </section>
</template>

<style lang="scss" src="./SWMailingList.scss"/>

<script lang="ts">

import SWPortalTasksService from '@/domains/SWPortalTask/SWPortalTasksService';

export default defineComponent({
  name: 'SWMailingList',

  props: {
    receivers: {
      type:     Array as PropType<any[]>,
      required: true,
    },
  },

  emits: ['update'],

  setup() {
    return {
      SWPortalTasksService,
    };
  },

  data() {
    return {
      addressInput: null as any,
    };
  },

  methods: {
    addEmployee(): void {
      const isDuplicate = this.receivers.some(employee => employee.id === this.addressInput.id);

      if (!isDuplicate) {
        this.$emit('update', [...this.receivers, this.addressInput]);
      }

      this.addressInput = null;
    },

    removeEmployee(index: number): void {
      const result = [...this.receivers];
      result.splice(index, 1);

      this.$emit('update', result);
    },
  },
});
</script>
